import React from 'react'
import { Route } from 'react-router-dom'
import PrivateRoute from '../Services/PrivateRouter'
import MainSetting from '../Views/Main/MainSetting'
import { Wrapper } from '../Components/Utils/roles'
import { CompanyInfo } from '../Views/Web/Settings/CompanyInfo'
import EditCompanyInfo from '../Views/Web/Settings/CompanyInfo/EditCompanyInfo'
import { CreateUser, EditUser, MainUserSettings, MainUserSettingsIndex, ViewUser } from '../Views/Web/Settings/User'
import MainEmailServerdetails from '../Views/Web/Settings/EmailServerDetails/MainEmailServerdetails'
import { CreateRole, EditRole, MainRole, MainRolesSettings, ViewRole } from '../Views/Web/Settings/Role'
import MainUserRoleSettings from '../Views/Web/Settings/UserRole/MainUserRole'
import MainJobRoleSettings from '../Views/Web/Settings/JobRole/MainJobRole'
import MainStatusPermission from '../Views/Web/Settings/StatusPermission/MainStatusPermission'
import MainNotification from '../Views/Web/Settings/Notification/MainNotification'
import ReffrenceSettings from '../Views/Web/Settings/Reffrence'
import MainClientManSetting from '../Views/Web/Settings/ClientManagement/Main'
import DropdownIndex from '../Views/Web/Settings/Dropdown'
import EnableDisIndex from '../Views/Web/Settings/EnableDisable'
import { EquipmentsCreate, EquipmentsEdit, EquipmentsMain, EquipmentsView, IndexEquipments } from '../Views/Web/Settings/Equipments/Index'
import NewApprovalIndex from '../Views/Web/Settings/NewApproval/Index'
import IndexInspector from '../Views/Web/Settings/Inspector/Index'
import MainInspectionSetting from '../Views/Web/Settings/Inspection/Main'
import MainCommisioningSetting from '../Views/Web/Settings/Commisioning/Main'
import MainRefillingSetting from '../Views/Web/Settings/Refilling/Main'
import MainInvoiceSetting from '../Views/Web/Settings/Invoice/Main'
import MainTicketsSetting from '../Views/Web/Settings/Tickets/Main'
import MainContactsSetting from '../Views/Web/Settings/Contacts/Main'
import TaskSettings from '../Views/Web/Settings/Task'
import MainEmail from '../Views/Web/Settings/EmailTemplate/MainEmail'
import MainTeamSetting from '../Views/Web/Settings/Team/MainTeam'
import MainEquipments from '../Views/Web/Settings/Equipments/MainEquipments'
import MainEquipSetting from '../Views/Web/Settings/Equipments/Main'
import IndexSurveyForm from '../Views/Web/Settings/SurveyForm'
import FormsApprove from '../Views/Web/Settings/FormsApprove/Survey'
import ViewApprove from '../Views/Web/Settings/FormsApprove/Survey/view'
import MainFormsApprove from '../Views/Web/Settings/FormsApprove/Main'
import MainSurvey from '../Views/Web/Settings/FormsApprove/Survey/Main'
import FormsInspectionApprove from '../Views/Web/Settings/FormsApprove/Inspection'
import MainInspection from '../Views/Web/Settings/FormsApprove/Inspection/Main'
import ViewInspectionApprove from '../Views/Web/Settings/FormsApprove/Inspection/view'
import NewViewIns from '../Views/Web/Settings/FormsApprove/Inspection/NewView'
import NewViewSur from '../Views/Web/Settings/FormsApprove/Survey/NewView'
import ContractMenuIndex from '../Views/Web/Settings/ContaractMenus'
import MainAdditionalMenus from '../Views/Web/Settings/FormsApprove/AdditionalMenus/Main'
import AdditionalMenusIndex from '../Views/Web/Settings/FormsApprove/AdditionalMenus'

function SettingRoutes() {
  return (
    <Route path="/settings" element={
        <PrivateRoute>
          <MainSetting />
        </PrivateRoute>
      }>
         <Route index element={ <Wrapper accessKey={"companyinfo_view"}  Component={CompanyInfo} />} />
        <Route path='company/edit' element={ <Wrapper accessKey={"companyinfo_edit"}  Component={EditCompanyInfo} /> } />
        <Route path='client-management' element={ <Wrapper accessKey={"clientmanagement_view"}  Component={MainClientManSetting} /> }/>
        <Route path='inspection' element={ <Wrapper accessKey={"inspection_view"}  Component={MainInspectionSetting} /> }/>
        <Route path='commisioning' element={ <Wrapper accessKey={"commisioning_view"}  Component={MainCommisioningSetting} /> }/>
        <Route path='refilling' element={ <Wrapper accessKey={"refilling_view"}  Component={MainRefillingSetting} /> }/>
        <Route path='invoice' element={ <Wrapper accessKey={"invoice_view"}  Component={MainInvoiceSetting} /> }/>
        <Route path='tickets' element={ <Wrapper accessKey={"tickets_view"}  Component={MainTicketsSetting} /> }/>
        <Route path='team' element={ <Wrapper accessKey={"store_view"}  Component={MainTeamSetting} /> }/>

        <Route path='contacts' element={ <Wrapper accessKey={"contacts_view"}  Component={MainContactsSetting} /> }/>
        <Route path='task' element={ <Wrapper accessKey={"task_view"}  Component={TaskSettings} /> }/>
        <Route path='user' element={ <MainUserSettings/>}>
          <Route index element={ <Wrapper accessKey={"user_view"}  Component={MainUserSettingsIndex} /> }/>
          <Route path='create' element={ <Wrapper accessKey={"user_create"}  Component={CreateUser} />} />
          <Route path='edit/:editUserId' element={ <Wrapper accessKey={"user_edit"}  Component={EditUser} />} />
          <Route path='view/:viewUserId' element={ <Wrapper accessKey={"user_view"}  Component={ViewUser} />} />
        </Route>
         {/* <Route path="equiments" element={<EquipmentsMain/>} >
                   <Route index element={<IndexEquipments/>} />
                   <Route path='create' element={<EquipmentsCreate/>} />
                   <Route path='edit/:EquipmentsEditId' element={<EquipmentsEdit/>} />
                   <Route path='view/:EquipmentsViewId' element={<EquipmentsView/>} />
                  </Route> */}
        <Route path='equiments' element={ <Wrapper accessKey={"equiments_view"}  Component={MainEquipSetting} /> }/>

        <Route path='emailserverdetails' element={ <Wrapper accessKey={"emailserver_view"}  Component={MainEmailServerdetails} />}/>
        {/* <Route path='emailserverdetails' element={ <Wrapper accessKey={true}  Component={MainEmailServerdetails} />}/> */}
        {/* <Route path='emailserverdetails' element={ <Wrapper accessKey={true}  Component={MainEmailServerdetails} />}/> */}
        <Route path='role' element={<MainRole/>}>
          <Route index element={ <Wrapper accessKey={"roles_view"}  Component={MainRolesSettings} /> } />
          <Route path='create' element={ <Wrapper accessKey={"roles_create"}  Component={CreateRole} /> } />
          <Route path='edit/:editRoleId' element={ <Wrapper accessKey={"roles_edit"}  Component={EditRole} /> } />
          <Route path='view/:viewRoleId' element={ <Wrapper accessKey={"roles_view"}  Component={ViewRole} /> } />
        </Route>
        {/* <Route path='currency-vat' element={ <Wrapper accessKey={true}  Component={MainCurrencyAndVatSettings} />}/> */}

        <Route path='user-role' element={ <Wrapper accessKey={"user_role_view"}  Component={MainUserRoleSettings} /> }/>
        <Route path='job-role' element={ <Wrapper accessKey={true}  Component={MainJobRoleSettings} /> }/>
        {/* <Route path='sealandsignature' element={ <Wrapper accessKey={true}  Component={MainSealPage} /> }/> */}
        <Route path='statuspermission' element={ <Wrapper accessKey={"approvalpermission_view"}  Component={MainStatusPermission} />}/>
        <Route path='notifications' element={ <Wrapper accessKey={"notification_view"}  Component={MainNotification} /> }/>
        <Route path='emailtemplate' element={ <Wrapper accessKey={"emailtemplates_view"}  Component={MainEmail} /> }/>
        <Route path='reffrence' element={ <Wrapper accessKey={"reference_view"}  Component={ReffrenceSettings} /> }/>
          <Route path='dropDowns' element={ <Wrapper accessKey={"dropDowns_view"}  Component={DropdownIndex} /> }/>
        <Route path='enableDisable' element={ <Wrapper accessKey={"enable_disable_view"}  Component={EnableDisIndex} /> }/>
        <Route path='newApproval' element={ <Wrapper accessKey={'approvalstatus_view'}  Component={NewApprovalIndex} />}/>
        <Route path='inspector' element={ <Wrapper accessKey={"inspector_view"}  Component={IndexInspector} /> }/>
        <Route path='surForm' element={ <Wrapper accessKey={"surForm_view"}  Component={IndexSurveyForm} />}/>
        
        <Route path='formsApprove' element={<MainRole/>}>
          <Route index element={ <Wrapper accessKey={"Form_Approve_view"}  Component={FormsApprove} /> } />
          {/* <Route path='create' element={ <Wrapper accessKey={"roles_create"}  Component={CreateRole} /> } />
          <Route path='edit/:editRoleId' element={ <Wrapper accessKey={"roles_edit"}  Component={EditRole} /> } /> */}
          <Route path='view' element={ <Wrapper accessKey={"forms_view"}  Component={ViewApprove} /> } />
        </Route>
        {/* <Route path='formsApprove' element={ <Wrapper accessKey={"Form_Approve_view"}  Component={FormsApprove} /> }/> */}
<Route path="formsApprove" element={<MainFormsApprove />}>
          <Route path="survey" element={<MainSurvey/>} >
           <Route index element={<FormsApprove/>} />
           {/* <Route path='viewSurvey' element={<ViewApprove/>} /> */}
           <Route path='viewSurvey/:viewIdsurvey' element={<ViewApprove/>} />

           {/* <Route path='viewFormSur' element={<NewViewSur/>} /> */}
           <Route path='viewFormSur/:viewIdsurvey' element={<NewViewSur/>} />

          </Route>

          <Route path="inspection" element={<MainInspection/>} >
           <Route index element={<FormsInspectionApprove/>} />
           {/* <Route path='viewInspection' element={<ViewInspectionApprove/>} /> */}
                      <Route path='viewInspection/:insIdsurvey' element={<ViewInspectionApprove/>} />

           {/* <Route path='viewFormIns' element={<NewViewIns/>} /> */}
           <Route path='viewFormIns/:insIdsurvey' element={<NewViewIns/>} />

          </Route>
          <Route path="additional-menus" element={<MainAdditionalMenus/>}>
            <Route index element={<AdditionalMenusIndex/>} />
          </Route>
          
      </Route>
        <Route path='contract-renewal' element={ <Wrapper accessKey={"surForm_view"}  Component={ContractMenuIndex} />}/>


         </Route>
  )
}

export default SettingRoutes